import React from 'react'
import { HistoryItem } from './types'
import { formatDate } from '../../utils/date'
import { Routes, TypedLink } from '../../routing'

const HistoryItem: React.FC<HistoryItem> = ({
  commentId,
  createdAt,
  content,
  id,
}) => {
  const commentLink = commentId ? (
    <>
      <TypedLink to={Routes.CommentDetails} params={{ id: commentId }}>
        Comment
      </TypedLink>{' '}
    </>
  ) : null

  return (
    <li key={id}>
      <b>{formatDate(createdAt)}</b> - {commentLink}
      {content}
    </li>
  )
}

export default HistoryItem
